import { takeLatest, put } from "redux-saga/effects";
import slice, {
  DELETE_STRIPE_SUBSCRIPTION_ITEM,
} from "store/stripe/subscriptionItems/slice";
import { deleteStripeSubscriptionItem } from "resources/services/stripeService";
import { FETCH_STRIPE_CUSTOMER } from "store/stripe/customer/slice";

function* fetch({ payload, meta }) {
  const { fetching, error, success } = slice.actions;

  yield put(fetching());
  try {
    yield deleteStripeSubscriptionItem(payload);

    meta?.onSuccess && meta.onSuccess();

    yield put(FETCH_STRIPE_CUSTOMER());
    yield put(success());
  } catch (e) {
    console.log(e);
    const errorMsg = e.message ? e.message : e;
    meta?.onError && meta.onError(errorMsg);
    yield put(error(errorMsg));
  }
}

export default function* watchDeleteSubscriptionItem() {
  yield takeLatest(DELETE_STRIPE_SUBSCRIPTION_ITEM.type, fetch);
}
